import { render } from "./ShopMerch.vue?vue&type=template&id=031d2a53"
import script from "./ShopMerch.vue?vue&type=script&lang=js"
export * from "./ShopMerch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__